import React from 'react';
import AppHeader from '../../common/app-header/AppHeader';
import DocumentVaultBlock from './DocumentVaultBlock';
import { useTranslation } from 'react-i18next';

const DocumentVault = () => {
  const { t } = useTranslation();
  return (
    <>
      <AppHeader title={t('headers.documentVault')} />
      <DocumentVaultBlock />
    </>
  );
};

export default DocumentVault;
